import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StompSubscription } from '@stomp/stompjs';
import { UUID } from 'angular2-uuid';
import { ChartOptions, ChartType } from 'chart.js';
import { Color, Label, SingleDataSet } from 'ng2-charts';
import { WebsocketService } from 'src/app/Services/websocket.service';

@Component({
  selector: 'ze-html',
  templateUrl: './html.component.html',
  styleUrls: ['./html.component.scss']
})
export class HtmlComponent implements OnInit {
  @Input() report: any;
  @Output() changetoStepwise  = new EventEmitter<any[]>();

  public objectKeys = Object.keys;
  selectedBrowser: string = '';
  iterationOptions: string[] = ['1'];
  selectedIteration: string = this.iterationOptions[0];
  statisticTableLoading: boolean = true;
  stepsTableLoading: boolean = true;
  chartGenerated: boolean = false;
  isBrowserIterationDataAvailable = false;
  currentReportLoadFailed = false;
  private stompSelectedBrowserIterationSubscription: StompSubscription;

  activeTab: string = 'Statistic';
  projectName: string;

  doughnutChartLabels: Label[];
  doughnutChartData: SingleDataSet;
  doughnutChartType: ChartType = 'doughnut';
  
  doughnutChartOptions: ChartOptions[] = [];
  chartOptionsTemplate: ChartOptions = {
    responsive: false,
    maintainAspectRatio: true,
    cutoutPercentage: 70,
    legend: {
      position: "bottom",
      reverse: true
    },
    title: {
      display: true
    }
  }

  doughnutChartColors: Color[];

  constructor(private websocketService: WebsocketService) {
    this.projectName = localStorage.getItem("projectName");
   }

  tableData: any[] = [];
  tableFootData: any;
  stepsTableData: any[] = [];

  ngOnInit() {
    this.activateTab(this.activeTab);
  }

  ngOnChanges() {
    this.activateTab(this.activeTab);
  }

  switchToStepwise(browserKey: string, iteration: string, order: number) {
    this.changetoStepwise.emit([browserKey, iteration, order]);
  }

  generateTableData(browserKey: string, iterNumber: string) {
    let fePassed = 0;
    let feFailed = 0;
    let feTotal = 0;
    let scPassed = 0;
    let scFailed = 0;
    let scTotal = 0;
    let stPassed = 0;
    let stFailed = 0;
    let stTotal = 0;
    let executionModelName = this.report.report_links.live_status[browserKey][iterNumber].name;
    let executionModelStatus = this.report.report_links.live_status[browserKey][iterNumber].status;
    let startTime = this.report.report_links.live_status[browserKey][iterNumber].startTime;
    let endTime = this.report.report_links.live_status[browserKey][iterNumber].endTime;
    if (this.report.report_links.live_status[browserKey][iterNumber].structure != undefined 
        && this.report.report_links.live_status[browserKey][iterNumber].structure.length > 0) {
      this.report.report_links.live_status[browserKey][iterNumber].structure.forEach(struct => {
        if (struct._type === "feature") {
          if (struct.status === "FAILED") {
            feFailed++;
            feTotal++;
          } else if (struct.status === "PASSED") {
            fePassed++;
            feTotal++;
          } else if (struct.status === "") {
            feTotal++;
          }
          if (struct.structure != undefined 
              && struct.structure.length > 0) {
            struct.structure.forEach(featStruct => {
              if (featStruct._type === "scenario") {
                if (featStruct.status === "FAILED") {
                  scFailed++;
                  scTotal++;
                } else if (featStruct.status === "PASSED") {
                  scPassed++;
                  scTotal++;
                } else if (featStruct.status === "") {
                  scTotal++;
                }
                if (featStruct.structure != undefined 
                  && featStruct.structure.length > 0) {
                    featStruct.structure.forEach(scenarioStruct => {
                    if (scenarioStruct.status === "FAILED") {
                      stFailed++;
                      stTotal++;
                    } else if (scenarioStruct.status === "PASSED") {
                      stPassed++;
                      stTotal++;
                    } else if (scenarioStruct.status === "") {
                      stTotal++;
                    }
                  });
                }    
              } else if (featStruct._type === "step") {
                if (featStruct.status === "FAILED") {
                  stFailed++;
                  stTotal++;
                } else if (featStruct.status === "PASSED") {
                  stPassed++;
                  stTotal++;
                } else if (featStruct.status === "") {
                  stTotal++;
                }
              }
            });
          }  
        } else if (struct._type === "scenario") {
          if (struct.status === "FAILED") {
            scFailed++;
            scTotal++;
          } else if (struct.status === "PASSED") {
            scPassed++;
            scTotal++;
          } else if (struct.status === "") {
            scTotal++;
          }
          if (struct.structure != undefined 
            && struct.structure.length > 0) {
            struct.structure.forEach(scenarioStruct => {
              if (scenarioStruct.status === "FAILED") {
                stFailed++;
                stTotal++;
              } else if (scenarioStruct.status === "PASSED") {
                stPassed++;
                stTotal++;
              } else if (scenarioStruct.status === "") {
                stTotal++;
              }
            });
          }
        } else if (struct._type === "step") {
          if (struct.status === "FAILED") {
            stFailed++;
            stTotal++;
          } else if (struct.status === "PASSED") {
            stPassed++;
            stTotal++;
          } else if (struct.status === "") {
            stTotal++;
          }
        }
      });
    }
    this.tableData = [
      { executionModelName: executionModelName, Fepassed: fePassed, Fefailed: feFailed, Fetotal: feTotal, Scpassed: scPassed, Scfailed: scFailed, Sctotal: scTotal, Stpassed: stPassed, Stfailed: stFailed, Sttotal: stTotal, duration: endTime-startTime, status: executionModelStatus },
    ];
    this.tableFootData = { Fepassed: feTotal>0?(fePassed/feTotal*100).toFixed(2):'', Fefailed: feTotal>0?(feFailed/feTotal*100).toFixed(2):'', Scpassed: scTotal>0?(scPassed/scTotal*100).toFixed(2):'', Scfailed: scTotal>0?(scFailed/scTotal*100).toFixed(2):'', Stpassed: stTotal>0?(stPassed/stTotal*100).toFixed(2):'', Stfailed: stTotal>0?(stFailed/stTotal*100).toFixed(2):'' };
    this.statisticTableLoading = false;
    this.generateChart();
  }

  activateTab(tab: string) {
    if (tab == 'Statistic' || tab == 'Steps') {
      if(this.selectedBrowser == '') {
        this.selectedBrowser = this.objectKeys(this.report.report_links.live_status)[0];
        this.selectedIteration = '1';
      }
      this.checkStepwiseDataAndUpdate();
      tab == 'Statistic' ? this.switchToStatisticTab(this.selectedBrowser, this.selectedIteration) : this.switchToStepsTab(this.selectedBrowser, this.selectedIteration);
    } else {
      this.activeTab = tab;
    }    
  }

  checkStepwiseDataAndUpdate() {
    this.isBrowserIterationDataAvailable = false;
    this.currentReportLoadFailed = false;
    if (this.report.report_links.live_status[this.selectedBrowser][this.selectedIteration]['structure'] != null) {
      this.isBrowserIterationDataAvailable = true;
    } else {
      this.getSelectedBrowserIterationData(this.report._id, this.selectedBrowser, this.selectedIteration, this.report.report_links.live_status[this.selectedBrowser][this.selectedIteration]['_id']);
    }
  }

  getSelectedBrowserIterationData(currentReportId, currentSelectedBrowser, currentSelectedIteration, browserIterationId) {   
    if (this.stompSelectedBrowserIterationSubscription) {
      this.stompSelectedBrowserIterationSubscription.unsubscribe();
    }
    let uuid: string = UUID.UUID();
    let currentBrowserIterationId: string = browserIterationId["$oid"]?browserIterationId["$oid"]:browserIterationId;
    this.stompSelectedBrowserIterationSubscription = this.websocketService.stompClient.subscribe('/message/browserIteration/id/' + uuid + '/browserIterationId/' + currentBrowserIterationId, (message) => {
      if (!(JSON.parse(message.body).operationStatus === "ERROR")) {
        if(this.report._id === currentReportId) {
          this.report.report_links.live_status[currentSelectedBrowser][currentSelectedIteration] = JSON.parse(message.body).data;
          this.isBrowserIterationDataAvailable = true;
          this.updateOnChangeBrowserOrIteration();
        }
      } else {
        // error in loading Current Report
        // this.currentReport = null;
        this.currentReportLoadFailed = true;
      }
    });
    let data = { browserIterationId: currentBrowserIterationId, execution: { dbName: this.report.dbName }, uuid: uuid };
  
    this.websocketService._sendBrowserIterationId(data);
  }

  updateSwitchTabData(browserKey: string, iterNumber: string) {
    this.selectedBrowser = browserKey;
    this.selectedIteration = iterNumber.toString();
    this.iterationOptions = this.objectKeys(this.report.report_links.live_status[this.selectedBrowser]);
  }

  generateStepsTableData(browserKey: string, iterNumber: string) {
    this.stepsTableData = [];
    let executionModelName = this.report.report_links.live_status[browserKey][iterNumber].name;
    let order = 1;
    if (this.report.report_links.live_status[browserKey][iterNumber].structure != undefined 
      && this.report.report_links.live_status[browserKey][iterNumber].structure.length > 0) {
      this.report.report_links.live_status[browserKey][iterNumber].structure.forEach(struct => {
        if (struct._type === "feature") {
          if (struct.structure != undefined 
              && struct.structure.length > 0) {
            struct.structure.forEach(featStruct => {
              if (featStruct._type === "scenario") {
                if (featStruct.structure != undefined 
                  && featStruct.structure.length > 0) {
                    featStruct.structure.forEach(scenarioStruct => {
                      scenarioStruct["order"] = order++;
                      scenarioStruct["suiteName"] = executionModelName;
                      scenarioStruct["stepName"] = struct.name + ' > ' + featStruct.name + ' > ' + scenarioStruct.name;
                      this.stepsTableData.push(scenarioStruct);
                  });
                }    
              } else if (featStruct._type === "step") {
                featStruct["order"] = order++;
                featStruct["suiteName"] = executionModelName;
                featStruct["stepName"] = struct.name + ' > ' + featStruct.name;
                this.stepsTableData.push(featStruct);
              }
            });
          }  
        } else if (struct._type === "scenario") {
          if (struct.structure != undefined 
            && struct.structure.length > 0) {
            struct.structure.forEach(scenarioStruct => {
              scenarioStruct["order"] = order++;
              scenarioStruct["suiteName"] = executionModelName;
              scenarioStruct["stepName"] = struct.name + ' > ' + scenarioStruct.name;
              this.stepsTableData.push(scenarioStruct);
            });
          }
        } else if (struct._type === "step") {
          struct["order"] = order++;
          struct["suiteName"] = executionModelName;
          struct["stepName"] = struct.name;
          this.stepsTableData.push(struct);
        }
      });
    }
    this.stepsTableLoading = false;
  }

  switchToStepsTab(browserKey: string, iterNumber: string) {
    this.stepsTableLoading = true;
    this.updateSwitchTabData(browserKey, iterNumber);
    this.activeTab = 'Steps';
    this.generateStepsTableData(browserKey, iterNumber);
  }

  switchToStatisticTab(browserKey: string, iterNumber: string) {
    this.statisticTableLoading = true;
    this.chartGenerated = false;
    this.updateSwitchTabData(browserKey, iterNumber);
    this.activeTab = 'Statistic';
    this.generateTableData(browserKey, iterNumber);
    console.log("my genreate data si", this.report)
  }

  generateChart() {
    this.doughnutChartData = [];
    this.doughnutChartLabels = [];
    this.doughnutChartColors = [];
    if (this.tableData[0].Fetotal > 0) {
      this.doughnutChartData.push([this.tableData[0].Fefailed, this.tableData[0].Fepassed]);
      let chartOptions = JSON.parse(JSON.stringify(this.chartOptionsTemplate));
      chartOptions.title.text = "Features";
      this.doughnutChartOptions.push(chartOptions);
    }
    if (this.tableData[0].Sctotal > 0) {
      this.doughnutChartData.push([this.tableData[0].Scfailed, this.tableData[0].Scpassed]);
      let chartOptions = JSON.parse(JSON.stringify(this.chartOptionsTemplate));
      chartOptions.title.text = "Scenarios";
      this.doughnutChartOptions.push(chartOptions);
    }
    if (this.tableData[0].Sttotal > 0) {
      this.doughnutChartData.push([this.tableData[0].Stfailed, this.tableData[0].Stpassed]);
      let chartOptions = JSON.parse(JSON.stringify(this.chartOptionsTemplate));
      chartOptions.title.text = "Steps";
      this.doughnutChartOptions.push(chartOptions);
    }
    if(this.doughnutChartData.length > 0) {
      this.doughnutChartLabels.push('FAILED');
      this.doughnutChartLabels.push('PASSED');
      this.doughnutChartColors.push({ backgroundColor: ['#F2928C', '#92DD96'] });
    }
    this.chartGenerated = true;
  }

  updateOnChangeBrowserOrIteration() {
    if (this.activeTab == 'Statistic') {
      this.statisticTableLoading = true;
      this.generateTableData(this.selectedBrowser, this.selectedIteration);
    } else if (this.activeTab == 'Steps') {
      this.stepsTableLoading = true;
      this.generateStepsTableData(this.selectedBrowser, this.selectedIteration);
    }
  }

  onChangeBrowser(valueOfBrowsers) {
    this.selectedBrowser = valueOfBrowsers.target.value;
    this.iterationOptions = this.objectKeys(this.report.report_links.live_status[this.selectedBrowser]);
    this.selectedIteration = this.iterationOptions[0];
    this.checkStepwiseDataAndUpdate();
    this.updateOnChangeBrowserOrIteration();
  }

  onChangIteration(valueOfIteration) {
    this.selectedIteration = valueOfIteration.target.value;
    this.checkStepwiseDataAndUpdate();
    this.updateOnChangeBrowserOrIteration();
  }
}
